import cx from 'classnames'
import { Icon } from '@/components/Icon'
import { match } from '@/utils/pattern-match-util'
import type { Glyph, Tone } from '@/features/jobs/job-status-display'
import styles from './StatusGlyph.module.css'

export interface StatusGlyphProps {
  glyph: Glyph
  tone: Tone
}

/**
 * Status glyphs differ in shape as well as colour so they stay readable in
 * greyscale and for colour-blind users.
 */
export function StatusGlyph({ glyph, tone }: StatusGlyphProps) {
  return (
    <span
      className={cx(
        styles.root,
        match(tone, {
          idle: () => styles.idle,
          active: () => styles.active,
          ready: () => styles.ready,
          warning: () => styles.warning,
          done: () => styles.done,
          muted: () => styles.muted,
        }),
      )}
      aria-hidden="true"
    >
      <Icon auto name={`status-${glyph}`} />
    </span>
  )
}
